const mutations = {
  addPageView(state) {
    state.pageViewCount += 1;
  },
  resetPageView(state) {
    state.pageViewCount = 0;
  },
  setUserRecommendations(state, input) {
    state.recommendedProducts = input;
  },
  setUserCartRecommendations(state, input) {
    state.recommendedCartProducts = input;
  }
};

export default mutations;
